import React, { useEffect } from 'react';
import { Body, Group } from '@qred/components-library';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';
import { useCountdownTimer } from '~/hooks/useCountdownTimer';
import useTranslate from '~/hooks/useTranslate';
import { setTimerCompleted } from '~/store/slices/additionalSigner.slice';
import { timestampIsInThePast } from '~/helpers/date.helper';

interface IAdditionalSignerOTPTimer {
  otpExpiryTimestamp: number;
}

const AdditionalSignerOTPTimer: React.FC<IAdditionalSignerOTPTimer> = ({
  otpExpiryTimestamp,
}) => {
  const {
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  const otpIsExpired = timestampIsInThePast(otpExpiryTimestamp);
  const dispatch = useDispatch();

  const { countdownTimer } = useCountdownTimer(otpExpiryTimestamp);
  const translate = useTranslate();

  useEffect(() => {
    if (otpIsExpired) {
      dispatch(setTimerCompleted(true));
    }
  }, [otpIsExpired]);

  return (
    <Group mt={mobile ? 32 : 40}>
      <Body size="md">
        {!otpIsExpired &&
          `${
            translate('AdditionalSigner.CodeExpirationText') as string
          }: ${countdownTimer}`}
      </Body>
    </Group>
  );
};

export default AdditionalSignerOTPTimer;
